// Imports
import React from 'react';
import Box from './box';
import DetailItem from './detail-item';


// Define the accepted props
type Detail = React.ComponentProps<typeof DetailItem>;

interface Props {
	details: Detail[];
}


// Function component
const DetailsBox: React.FC<Props> = ({ details }) => {
	// Return JSX
	return (
		<Box>
			{details.map((detail, i) => (
				<DetailItem key={i} {...detail} />
			))}
		</Box>
	);
};

export default DetailsBox;
